// Bands added by hand to a night that was booked through Play at Dillon. The sheet keeps the
// headliner's name in column C (the event URL is built from it), so extra bands live here,
// keyed by event slug, until bookings support several acts. Same shape as publicBandInfo().
export const SUPPORT_ACTS = {
    '2026-11-06-nei': [
        {
            label: 'Also playing',
            band_name: 'Tófa',
            genre: 'Noise punk',
            based_in: 'Reykjavík',
            bio: [
                'Tófa is a noise-punk band formed in Iceland in 2015. Influenced by long books, noise and vicious animals, the music is the deranged result of happy people doing angry things. That embodies the animal after which the band is named; Tófa (the arctic fox) is cute and cuddly on the outside but vicious and bloodthirsty on the inside.',
                'In 2024 Tófa released the band’s third album, Mauled, and has recorded the fourth which will be released soon.',
            ].join('\n\n'),
            press_photo: '/img/acts/tofa.jpg',
            links: {},
        },
    ],
};

export const supportActsFor = (slug) => SUPPORT_ACTS[slug] || [];
